export var DEFAULT_DOMAIN = 'https://www.googletagmanager.com';
export var DEFAULT_SCRIPT_NAME = 'gtm.js';
/**
 * Function to get and set dataLayer
 * @param dataLayer - The dataLayer
 * @param dataLayerName - The dataLayer name
 */

export var getDataLayerSnippet = function getDataLayerSnippet(dataLayer) {
  var dataLayerName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dataLayer';
  return "window.".concat(dataLayerName, " = window.").concat(dataLayerName, " || [];") + (dataLayer ? "window.".concat(dataLayerName, ".push(").concat(JSON.stringify(dataLayer), ")") : '');
};
/**
 * Function to get the Iframe snippet
 * @param environment - The parameters to use a custom environment
 * @param customDomain - Custom domain for gtm
 * @param id - The id of the container
 */

export var getIframeSnippet = function getIframeSnippet(id, environment) {
  var customDomain = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_DOMAIN;
  var params = "";

  if (environment) {
    var gtm_auth = environment.gtm_auth,
        gtm_preview = environment.gtm_preview;
    params = "&gtm_auth=".concat(gtm_auth, "&gtm_preview=").concat(gtm_preview, "&gtm_cookies_win=x");
  }

  return "<iframe src=\"".concat(customDomain, "/ns.html?id=").concat(id).concat(params, "\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" id=\"tag-manager\"></iframe>");
};
/**
 * Function to get the GTM script
 * @param dataLayerName - The name of the dataLayer
 * @param customDomain - Custom domain for gtm
 * @param customScriptName - Custom script file name for gtm
 * @param environment - The parameters to use a custom environment
 * @param id - The id of the container
 */

export var getGTMScript = function getGTMScript(dataLayerName, id, environment) {
  var customDomain = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_DOMAIN;
  var customScriptName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : DEFAULT_SCRIPT_NAME;
  var params = "";

  if (environment) {
    var gtm_auth = environment.gtm_auth,
        gtm_preview = environment.gtm_preview;
    params = "+\"&gtm_auth=".concat(gtm_auth, "&gtm_preview=").concat(gtm_preview, "&gtm_cookies_win=x\"");
  }

  return "\n    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n      '".concat(customDomain, "/").concat(customScriptName, "?id='+i+dl").concat(params, ";f.parentNode.insertBefore(j,f);\n    })(window,document,'script','").concat(dataLayerName, "','").concat(id, "');\n  ");
};